import styled from 'styled-components';

const DivMiddleTag = styled.div`
${props=>
    props.styleString && `${props.styleString}`}
`;

const ImageMiddleTag = styled.img`
    ${props=>
    props.styleString && `${props.styleString}`}
`;

export {DivMiddleTag,ImageMiddleTag}


// WEBPACK FOOTER //
// ./src/components/preview/MiddleTag.styled.tsx